import { graphql } from '../../graphql';

export const getSEOData = graphql(`
  query GetSEO($path: Path!) {
    seo(path: $path) {
      id
      title
      description
      h1
    }
  }
`);

export const getItemSEOQuery = graphql(`
  query CurrentItemSEO($id: ID!) {
    item(id: $id) {
      id
      metaTags {
        name
        content
      }
    }
  }
`);
